import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 100">
    <title>Loader Logo</title>
    <g>
      <text
        id="B"
        x="250"
        y="60"
        fill="currentColor"
        stroke="none"
        fontSize="60"
        fontFamily="'Dancing Script', cursive"
        textAnchor="middle">
        <tspan>H</tspan>
        <tspan>e</tspan>
        <tspan>l</tspan>
        <tspan>l</tspan>
        <tspan>o</tspan>
        <tspan>.</tspan>
        <tspan> </tspan>
        <tspan>I</tspan>
        <tspan>'</tspan>
        <tspan>m</tspan>
        <tspan> </tspan>
        <tspan>M</tspan>
        <tspan>y</tspan>
        <tspan>r</tspan>
        <tspan>o</tspan>
        <tspan>n</tspan>
      </text>
    </g>
  </svg>
);

export default IconLoader;
